import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";
import { DocumentInputContentV1 } from "@demo/types/documentContent";

export const discordTicketExample: TemplateDefinition = {
  mode: "compose",
  slug: "discord-ticket",
  version: 1,
  title: "Desktop use",
  description: "Determine next action",
  thumbnailUuid: BASE_ASSETS.discordScreenshot.uuid,
  assets: [BASE_ASSETS.discordScreenshot],
  request: {
    model: "perceptron-mk1.5",
    system: [],
    user: [
      {
        type: "media",
        value: [
          {
            type: "image",
            value: {
              uuid: BASE_ASSETS.discordScreenshot.uuid,
              extension: BASE_ASSETS.discordScreenshot.extension,
              annotations: { points: [], boundingBoxes: [] },
            },
          },
        ],
      },
      {
        type: "paragraph",
        value: {
          type: "text",
          value: "Open a ticket.",
        },
      },
    ],
    outputAnnotations: false,
    variables: {},
    annotationFormat: "point",
    enableThinking: true,
  } satisfies DocumentInputContentV1,
};
